/* eslint-disable */
// This is auto generated code, do not edit directly
// @ts-ignore
import * as Types from '../../../../core/graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCurrentUserQueryVariables = Types.Exact<{
	[key: string]: never;
}>;

export type GetCurrentUserQuery = {
	__typename?: 'Query';
	currentUser: {
		__typename?: 'User';
		id: any;
		email: string;
		dcrEnabled: boolean;
	};
};

export const GetCurrentUserDocument = gql`
	query GetCurrentUser {
		currentUser {
			id
			email
			dcrEnabled
		}
	}
`;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetCurrentUserQuery,
		GetCurrentUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(
		GetCurrentUserDocument,
		options
	);
}
export function useGetCurrentUserLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetCurrentUserQuery,
		GetCurrentUserQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(
		GetCurrentUserDocument,
		options
	);
}
export function useGetCurrentUserSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetCurrentUserQuery,
				GetCurrentUserQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetCurrentUserQuery,
		GetCurrentUserQueryVariables
	>(GetCurrentUserDocument, options);
}
export type GetCurrentUserQueryHookResult = ReturnType<
	typeof useGetCurrentUserQuery
>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<
	typeof useGetCurrentUserLazyQuery
>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<
	typeof useGetCurrentUserSuspenseQuery
>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<
	GetCurrentUserQuery,
	GetCurrentUserQueryVariables
>;
